import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const abilitiesApi = {
  getAbilitiesByPhase: async (phaseName, sessionId) => {
    const response = await axiosInstance.get("/abilities", {
      params: { phase: phaseName,
        ...(sessionId && { sessionId }),
       },
    });
    return response.data.data;
  },
  getAbilityById: async (abilityId) => {
    const response = await axiosInstance.get(`/abilities/${abilityId}`);
    return response.data.data;
  },
};

export const useAbilitiesByPhase = (phaseName, sessionId) => {
  return useQuery({
    queryKey: ["abilities", phaseName, sessionId],
    queryFn: () =>
      phaseName
        ? abilitiesApi.getAbilitiesByPhase(phaseName, sessionId)
        : Promise.resolve([]),
    enabled: !!phaseName && !!sessionId,
  });
};

export const useAbilityById = (abilityId) => {
  return useQuery({
    queryKey: ["ability", abilityId],
    queryFn: () =>
      abilityId
        ? abilitiesApi.getAbilityById(abilityId)
        : Promise.resolve(null),
    enabled: !!abilityId,
  });
};
